export const progressPages = [
  {
    id: 1,
    isEnabled: false,
    isActive: true,
    isComplete: false,
    name: "Assessment details",
    route: "profile",
  },
  {
    id: 2,
    isEnabled: false,
    isActive: false,
    isComplete: false,
    name: "Scope details",
    route: "scope",
  },
  {
    id: 3,
    isEnabled: false,
    isActive: false,
    isComplete: false,
    name: "Review profile",
    route: "review",
  },
];

export const progressPagesItil = [
  {
    id: 1,
    isEnabled: false,
    isActive: true,
    isComplete: false,
    name: "Assessment details",
    route: "profile/itil",
  },
  {
    id: 2,
    isEnabled: false,
    isActive: false,
    isComplete: false,
    name: "Scope details",
    route: "scope/itil",
  },
  {
    id: 3,
    isEnabled: false,
    isActive: false,
    isComplete: false,
    name: "Review profile",
    route: "review/itil",
  },
];
